export default "__VITE_ASSET__26c60c16__"